<span class="svg-icon svg-icon--{{ size() }}">
  @let iconName = icon();
  @let appName = app();
  @let fileName = file();
  @let url = imgUrl();
  @let altText = alt();
  @let svg = svgPath();

  @if (url || appName || fileName) {
    @if (url) {
      <img
        [src]="url"
        [attr.alt]="altText"
        class="svg-icon__img" />
    } @else if (appName) {
      <img
        [src]="basePath()() + 'applications/' + appName + '.svg'"
        [attr.alt]="altText"
        class="svg-icon__img" />
    } @else if (fileName) {
      <img
        [src]="basePath()() + 'icons/files/' + fileName + '.svg'"
        [attr.alt]="altText"
        class="svg-icon__img" />
    }
  } @else {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      focusable="false"
      class="svg-icon__symbol">
      @if (altText) {
        <title>{{ altText }}</title>
      }
      @if (iconName) {
        <use attr.xlink:href="{{ basePath()() }}icons/sprite/sprite.svg#{{ iconName }}"></use>
      } @else if (svg) {
        <use [attr.xlink:href]="svg"></use>
      }
    </svg>
  }
</span>
